export const IS_ADMIN = 'is-admin';
export const IS_NAV4_TENANT_OPT_IN = 'is-nav4-tenant-opt-in';
export const IS_NAV4_TENANT_OPT_OUT = 'is-nav4-tenant-opt-out';
export const IS_NAV4_USER_OPT_IN = 'is-nav4-user-opt-in';
export const IS_NAV4_USER_OPT_OUT = 'is-nav4-user-opt-out';

export type ApplicationPropertyKey = typeof IS_NAV4_TENANT_OPT_IN | typeof IS_NAV4_TENANT_OPT_OUT;
export type UserPropertyKey = typeof IS_NAV4_USER_OPT_IN | typeof IS_NAV4_USER_OPT_OUT;
